import React, {useContext} from 'react';
import NavbarMyhome from '../../components/NavbarMyhome';
import {LangContext} from '../../components/LangProvider';
import Search from '../../components/Search';
import Button from 'react-bootstrap/Button';

function HeaderMyhome(props){
  //** props */
  const {toggleMemo, memoShown, setSearchString, resetSearchResult, toggleTidy, tidy, pathUserid} = props
  //** context */
  const {lang} = useContext(LangContext);
  const t = lang.HeaderMyhome
  const baseUrl = window.location.origin;
  const bookmarklet = `<a href="javascript:var d=document,w=window,e=w.getSelection,k=d.getSelection,x=d.selection,s=(e?e():(k)?k():(x?x.createRange().text:'')),f='${baseUrl}/${pathUserid}',l=d.location,e=encodeURIComponent,u=f+'?u='+e(l.href)+'&t='+e(d.title)+'&s='+e(s);a=function(){if(!(z=w.open(u,'t'))){l.href=u;}else{z.focus();}};if(navigator.userAgent.indexOf('Firefox') != -1)setTimeout(a,0);else a();void(0)"><span className="label label-info" title="Drag this bookmarklet to your browser bookmarkbar" >${t.bookmarklet}</span></a>`;
  //** props */
  const SearchProps = {setSearchString, resetSearchResult}
  return(
      <>     
      {/* <!-- Navigation --> */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container">
          <button className="btn btn-link bookmarklet" dangerouslySetInnerHTML={{__html: bookmarklet}}></button>
          <Button variant="secondary" onClick={toggleMemo}><i className={memoShown?"memoHidden":"memoShown"}></i></Button>
          <Button variant="secondary" onClick={toggleTidy}><i className={tidy===1?"tidy1":(tidy===2)?"tidy2":"tidy3"}></i></Button>
          <Search {...SearchProps}/>
          <NavbarMyhome {...props}/>
        </div>
      </nav>
      </>
  );
}

export default HeaderMyhome;